
import { textHeights } from 'ol/render/canvas';
import { 
  WDCardList, 
  WDApi 
} from 'wd';


/**
  Events:
  kiosks:selected -> when an kiosk is picked, it passes the kiosk back to the caller
  */

export default class LookupCard extends WDCardList
{
  #cardList;

  constructor(cfg)
  {
    super(cfg);

    window.addEventListener('hammerspoon:activate',() => this.handleHammerActivated() );
    this.on('card:shown',() => this.selectSearch());
  };

  connectedCallback()
  {
    super.connectedCallback();

    this.reqList(this.listConfig);

    this.addSearchArrows();
  
    this.cardList.on('company:selected',() => {

      if (this.company)
      {
        this.handleCompanyChange();

        //set a lag here so the company form has time to finish
        //setTimeout(() => this.selectSearch(), 100);
      }
      else
      {
        this.list.proxy.replace([]);
      }
        
    });

    this.list.on('item:selected',(evt) => {
      this.handleSelected(evt);
    });

    this.list.on('list:nav-escape', (evt) => {
      this.searchField().focus();
    });

  };

  handleCompanyChange()
  {
    //resets the fetch uri with the current company
    if (this.list.fetch)
    {
      this.list.fetch.setReqURI(this.fetchURI);
    }
    else
    {
      this.list.fetch = this.fetchApi;
    }
   
    this.list.req().then(() => this.selectSearch());
  };

  get cardList() {
    if (!this.#cardList)
    {
      this.#cardList = this.closest('lookup-cards');
    }

    return this.#cardList;
  }

  addSearchArrows()
  {
    setTimeout(() =>
    {
      this.searchField().addEventListener('keydown', evt =>
      {
        if (evt.key == 'ArrowDown')
        {
          evt.preventDefault();
          this.list.focusFirstItem();
        }
      });
    }, 250);

  };

  handleHammerActivated()
  {
    if (this.company) 
    {
      this.selectSearch();
    }
    else
    {
      this.cardList.companySelector.focus();
    }

    if (this.list && this.list.items.length > 0)
    {
      this.list.resetSelectedIndex();
    }
  }

  searchField()
  {
    return this.querySelector('input[name="search_string"]');
  }

  selectSearch()
  {
    if (!this.company) return;

    if (this.classList.contains('is-active'))
    {
      const ss = this.searchField();
      if (ss)
      {
        ss.focus();
        ss.select();
      }
    }

  };

  get company() { return this.cardList.company; };

  get fetchApi()
  {
    return new WDApi(this.fetchURI);
  }

  get fetchURI()
  {
    return `/lookup/companies/${this.company.value}/glaccounts`;
  }

  get listConfig()
  {
    return {};
  };

  triggerHammer(evt,data)
  {
    evt.preventDefault();
    console.log('Sending data back to HS',data);
    window.location.href = "hammerspoon://lookupresult?value=" + encodeURIComponent(data);
  }
}

customElements.define('lookup-card',LookupCard);

